<div
  class="mb-5 aspect-news relative cursor-pointer flex flex-col justify-end text-white rounded-8 p-12 max-sm:p-5 max-xl:p-8"
  [ngStyle]="{
    'background-image': 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4))',
    'background-size': 'cover',
    'background-position': 'center'
  }"
>
  <div class="max-w-[700px]">
    <div class="pb-5 max-sm:pb-2 flex flex-col gap-2">
      <div class="bg-grey-skeleton animate-pulse w-full h-[25px]"></div>
      <div class="bg-grey-skeleton animate-pulse w-[60%] h-[25px]"></div>
    </div>
    <div class="flex flex-col gap-2 font-roboto-400 text-12 max-sm:text-10">
      <div class="bg-grey-skeleton animate-pulse w-full h-[15px]"></div>
      <div class="bg-grey-skeleton animate-pulse w-[30%] h-[15px]"></div>
    </div>
  </div>
</div>
